import React from 'react'

const Product = ({ productData, paginationHandler, buttonDisable, editHadler, count }) => (
    <div className='container-fluid' style={{ marginTop: '40px' }}>
        {productData !== '' && productData !== undefined ?
            <div>
                <div className='overflow-auto'>
                    <table className='phocket-table'>
                        <thead>
                            <tr>
                                <th>Cheque Bounce Charge</th>
                                <th>EMI Penalty Interest</th>
                                <th>Emi Type</th>
                                <th>GST Included</th>
                                <th>GST Interest</th>
                                <th>Interest Type</th>
                                <th>Mandate Bounce Charge</th>
                                <th>Normal Interest</th>
                                <th>Penalty Amount</th>
                                <th>Penalty Interest</th>
                                <th>Previously Affect</th>
                                <th>ROI Reflect Date</th>
                                <th>StampDuty Charge</th>
                                <th>Edit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productData?productData.map((nbfc, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{nbfc.chequeBounceCharge}</td>
                                        <td>{nbfc.emiPenaltyInterest}</td>
                                        <td>{nbfc.emiType}</td>
                                        <td>{nbfc.gstIncluded === false ? 'No' : nbfc.gstIncluded === true ? 'Yes' : ""}</td>
                                        <td>{nbfc.gstInterest}</td>
                                        <td>{nbfc.interestType}</td>
                                        <td>{nbfc.mandateBounceCharge}</td>
                                        <td>{nbfc.normalInterest}</td>
                                        <td>{nbfc.penaltyAmount}</td>
                                        <td>{nbfc.penaltyInterest}</td>
                                        <td>{nbfc.previouslyAffect === false ? 'No' : nbfc.previouslyAffect === true ? 'Yes' : ""}</td>
                                        <td>{nbfc.roiReflectDate}</td>
                                        <td>{nbfc.stampDutyCharge}</td>
                                        <td><i className='fa fa-edit' style={{ cursor: 'pointer' }} onClick={() => editHadler(nbfc, 'edit')}></i></td>

                                    </tr>
                                )
                            }):""}
                        </tbody>
                    </table>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" id="backword" onClick={e => paginationHandler('left')}><span className="fa fa-chevron-left" /></button></div>
                        <div className="col-sm-2 col-xs-12  phoc text-center" >Total: {productData.length}&nbsp; of &nbsp; {count}</div>
                        <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" disabled={buttonDisable} className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" id="forword" onClick={e => paginationHandler('right')}><span className="fa fa-chevron-right" /></button></div> </div>
                </div>
            </div>
            : ""}
    </div>
)
export default Product